package com.milta.core.localization.translations.bg

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Отказ",
    confirm = "Потвърди",
    save = "Запази",
    delete = "Изтрий",
    back = "Назад",
    loading = "Зареждане…",
    retry = "Опитай отново",
    language = "Език",
    welcomeTitle = "Добре дошли в Milta",
    welcomeSubtitle = "Вашият интелигентен асистент за доставки",
    alreadyHaveAccount = "Вече имам акаунт",
    createAccount = "Създай акаунт",
    continueWithGoogle = "Продължете с Google",
    continueWithApple = "Продължете с Apple",
    oauthErrorGeneric = "Възникна грешка при влизането. Опитайте отново.",
    oauthAppleWebComingSoon = "Влизането с Apple ще бъде налично скоро в уеб версията.",
    oauthDriverAccountNotAllowedOnWeb = "Профилите на шофьори нямат достъп до уеб таблото. Влезте през мобилното приложение.",
    oauthAccountNotFoundOnWeb = "Не е намерен акаунт в Milta за този Google акаунт.",
    errorOffline = "Няма връзка с интернет.",
    navTourneesDuJour = "Днешни маршрути",
    navAjouterUneTournee = "Добавяне на маршрут",
    navHistoriqueDesPreuves = "История на доставките",
    navParametres = "Настройки",
    sidebarRoleManagerLabel = "Мениджър",
    noDeliveriesYetTitle = "Все още няма доставки",
    noDeliveriesYetSubtitle = "Докоснете „Добавяне на доставки“, за да добавите",
    optimizationUnavailableExplanation = "Искате ли да създадете маршрута без оптимизация, или да опитате отново?",
    createWithoutOptimizationAction = "Създай без оптимизация",
    gpsAppSheetTitle = "Изберете навигационно приложение",
    addressSearchingLabel = "Търсене…",
)
